import { Container, Card } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function TermsOfUse() {
  return (
    <Container className="py-5" style={{ maxWidth: 900 }}>
      <Card className="brutal-card">
        <Card.Body className="p-5">
          <Card.Title className="brutal-heading mb-4" style={{ fontSize: "36px" }}>
            TERMS OF USE
          </Card.Title>
          
          <div className="brutal-text" style={{ lineHeight: "1.8", fontSize: "14px" }}>
            <p className="mb-4">
              <strong>Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</strong>
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              1. ACCEPTANCE OF TERMS
            </h3>
            <p className="mb-4">
              By accessing and using Time Registry ("the Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to abide by the above, please do not use this service.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              2. DESCRIPTION OF SERVICE
            </h3>
            <p className="mb-4">
              Time Registry is a digital platform that allows users to purchase and register ownership of specific calendar dates. Each date can be owned by one user at a time, and ownership includes a digital certificate and the ability to customize the date's title and description.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              3. USER ACCOUNTS
            </h3>
            <p className="mb-4">
              To use Time Registry, you must create an account. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              4. PURCHASES AND PAYMENTS
            </h3>
            <p className="mb-4">
              All purchases are processed through Stripe. By making a purchase, you agree to pay the specified amount for the selected date. Prices are subject to change without notice. All sales are final, and refunds are at the sole discretion of Time Registry.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              5. OWNERSHIP AND RIGHTS
            </h3>
            <p className="mb-4">
              Purchasing a date grants you digital ownership rights to that specific date within the Time Registry platform. This ownership is symbolic and does not grant any legal rights to the actual calendar date. You may customize the title and description of your owned dates, subject to our content policies.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              6. PROHIBITED ACTIVITIES
            </h3>
            <p className="mb-4">
              You agree not to:
            </p>
            <ul className="mb-4" style={{ paddingLeft: "20px" }}>
              <li>Use the Service for any illegal purpose or in violation of any laws</li>
              <li>Attempt to gain unauthorized access to the Service or its related systems</li>
              <li>Interfere with or disrupt the Service or servers connected to the Service</li>
              <li>Use automated systems to purchase dates or manipulate the Service</li>
              <li>Post or transmit any content that is offensive, defamatory, or violates any third-party rights</li>
            </ul>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              7. CONTENT AND INTELLECTUAL PROPERTY
            </h3>
            <p className="mb-4">
              All content on Time Registry, including but not limited to text, graphics, logos, and software, is the property of Time Registry or its content suppliers and is protected by copyright and other intellectual property laws. You may not reproduce, distribute, or create derivative works from any content without our express written permission.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              8. DISCLAIMER OF WARRANTIES
            </h3>
            <p className="mb-4">
              THE SERVICE IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              9. LIMITATION OF LIABILITY
            </h3>
            <p className="mb-4">
              TO THE MAXIMUM EXTENT PERMITTED BY LAW, TIME REGISTRY SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES, OR ANY LOSS OF PROFITS OR REVENUES, WHETHER INCURRED DIRECTLY OR INDIRECTLY, OR ANY LOSS OF DATA, USE, GOODWILL, OR OTHER INTANGIBLE LOSSES.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              10. MODIFICATIONS TO TERMS
            </h3>
            <p className="mb-4">
              Time Registry reserves the right to modify these Terms of Use at any time. We will notify users of any material changes by posting the new Terms of Use on this page. Your continued use of the Service after such modifications constitutes acceptance of the updated terms.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              11. TERMINATION
            </h3>
            <p className="mb-4">
              We reserve the right to terminate or suspend your account and access to the Service immediately, without prior notice, for conduct that we believe violates these Terms of Use or is harmful to other users, us, or third parties, or for any other reason.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              12. GOVERNING LAW
            </h3>
            <p className="mb-4">
              These Terms of Use shall be governed by and construed in accordance with the laws of the jurisdiction in which Time Registry operates, without regard to its conflict of law provisions.
            </p>

            <h3 className="brutal-subheading mt-4 mb-3" style={{ fontSize: "20px" }}>
              13. CONTACT INFORMATION
            </h3>
            <p className="mb-4">
              If you have any questions about these Terms of Use, please contact us through the Service or at the contact information provided on our website.
            </p>

            <div className="mt-5 pt-4 border-top" style={{ borderTop: "4px solid #000000" }}>
              <Link to="/" className="brutal-link" style={{ textDecoration: "underline", textDecorationThickness: "2px" }}>
                ← BACK TO HOME
              </Link>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
